export const SET_REDUX_STATE = "SET_REDUX_STATE";
export const SET_INITIAL_VALUE = "SET_INITIAL_VALUE";
export const ADD_FILTER = 'UPDATE_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';